import { render, staticRenderFns } from "./PublicGlobalNavigation.vue?vue&type=template&id=11b4893e&lang=pug&"
import script from "./PublicGlobalNavigation.vue?vue&type=script&lang=js&"
export * from "./PublicGlobalNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports